export class Event {
    name: string = '';
    startTime: string = '';
    endTime: string = '';
    id: string = '';
    constructor(id:string) {
        this.id = id;
    }


   static fromApiResponse(data: any ){
        const event = new this(data.id);
        event.name = data.attributes.name
        event.startTime = data.attributes.startTime.short;
        event.endTime = data.attributes.endTime.short;
       return event;
    }
}